import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@mobileia/core';
import { MiaAuthHttpService, AuthenticationService } from '@mobileia/authentication';
import { environment } from 'src/environments/environment';

export interface CouponPreviewResponse {
  valid: boolean;
  amount: number;
  code: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CouponService extends MiaAuthHttpService {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
  }

  preview(code: string, fingerprint: string): Observable<ApiResponse<CouponPreviewResponse>> {
    return this.postAuthObject(environment.baseUrl + 'coupon/preview', { code: code, fingerprint: fingerprint });
  }
}
